import { LOCAL_STORAGE_TOKEN_KEY } from 'constants/auth'
import { ESTABLISHMENT_APP_TIMESTAMP_VERSION_KEY } from 'constants/establishment'
import { toast } from 'react-toastify'
import { getItemLocalStorage, removeItemLocalStorage, setItemLocalStorage } from 'utils/local-storage'

const applyInterceptors = (axiosInstance) => {
  // Interceptor de solicitud
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = getItemLocalStorage(LOCAL_STORAGE_TOKEN_KEY)
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
      return config
    },
    (error) => Promise.reject(error)
  )

  // Interceptor de respuesta
  axiosInstance.interceptors.response.use(
    (response) => {
      const appTimestampVersion = Number(response.data?.app_timestamp_version)

      if (!isNaN(appTimestampVersion) && appTimestampVersion > 0) {
        const currentAppTimestampVersion = Number(getItemLocalStorage(ESTABLISHMENT_APP_TIMESTAMP_VERSION_KEY))

        if (appTimestampVersion > currentAppTimestampVersion) {
          setItemLocalStorage(ESTABLISHMENT_APP_TIMESTAMP_VERSION_KEY, appTimestampVersion)
          window.location.reload()
        }
      }

      return response
    },
    (error) => {
      if (error.response?.status === 401) {
        if (error.response?.data?.session_expired) {
          removeItemLocalStorage(LOCAL_STORAGE_TOKEN_KEY)
          window.location.reload()
        }
        console.error(error.response)
      }

      if (error.response?.status === 403) {
        if (error.response?.data?.contract_expired) {
          toast.error(error.response.data.message || 'El contrato ha expirado. Por favor, contacte con el proveedor.')
        }
        if (error.response?.data?.certificate_expired) {
          toast.error(error.response.data.message || 'El certificado digital ha expirado. Por favor, contacte con el proveedor.')
        }
        console.error(error.response)
      }

      if (error.response?.status === 500) {
        if (error.response?.data?.message) {
          toast.error(error.response.data.message || 'Ha ocurrido un error interno del servidor. Por favor, inténtelo de nuevo más tarde.')
        }
        console.error(error.response)
      }

      return Promise.reject(error)
    }
  )
}

export default applyInterceptors